import { QueueKey } from 'flow/types/EntityKeys';

/** The id that PbxQueueV2 gives its page's scroller. */
export const QUEUE_PAGE_SCROLLER_ID = 'main-scrollable-div';

const storageKey = (queueKey: QueueKey) => `queue-scroll-${queueKey}`;

// Reading sessionStorage throws where storage is blocked, as in a frame
// without storage access, and writing it throws when it is full. The position
// is a convenience, so then there is none.
const withStorage = <Result>(
    action: (storage: Storage) => Result,
): Result | null => {
    try {
        return action(sessionStorage);
    } catch {
        return null;
    }
};

/**
 * Keeps where the queue page is scrolled while a call's page is open, so Back
 * brings the user to the call they opened. The call's page has a scroller
 * with the same id, so the position is saved before that page mounts: on the
 * click that opens it.
 */
export const saveQueueScrollPosition = (queueKey: QueueKey) => {
    const scroller = document.getElementById(QUEUE_PAGE_SCROLLER_ID);
    if (scroller) {
        withStorage((storage) =>
            storage.setItem(storageKey(queueKey), String(scroller.scrollTop)),
        );
    }
};

/** The saved position, or null. It is forgotten once taken. */
export const takeQueueScrollPosition = (queueKey: QueueKey) =>
    withStorage((storage) => {
        const saved = storage.getItem(storageKey(queueKey));
        storage.removeItem(storageKey(queueKey));
        return saved === null ? null : Number(saved);
    });

export const forgetQueueScrollPosition = (queueKey: QueueKey) =>
    withStorage((storage) => storage.removeItem(storageKey(queueKey)));
